import { render, staticRenderFns } from "./Traslado.vue?vue&type=template&id=0f5297d7&scoped=true"
import script from "./Traslado.vue?vue&type=script&lang=js"
export * from "./Traslado.vue?vue&type=script&lang=js"
import style0 from "./Traslado.vue?vue&type=style&index=0&id=0f5297d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5297d7",
  null
  
)

export default component.exports